import { useEffect, useState } from 'react'

import { countDecimalPlaces } from '../../../../utils/count-decimal-places'

import { floorNumber } from '../../../../utils/floor-number'

import { formatNumberWithSpaces } from '../../../../utils/format-number-with-spaces'

import styles from './styles.module.scss'
import { DashboardSavingsProps } from './dashboard-savings.props'
import { useTranslation } from 'utils/use-translation'
import { useAppSelector } from 'store/hooks'
import { allWallets } from 'store/reducers/wallets'

export default function DashboardSavings({ savings }: DashboardSavingsProps) {
  const { t } = useTranslation()

  const [totalEarns, setTotalEarns] = useState<number>(0)
  const [totalAmount, setTotalAmount] = useState<number>(0)
  const wallets = useAppSelector(allWallets)

  useEffect(() => {
    if (savings.length) {
      calculateTotalAmounts()
    }
  }, [savings, wallets])

  const calculateTotalAmounts = () => {
    try {
      let amount = 0
      let earn = 0

      savings.forEach((it) => {
        const wallet = wallets.find(w =>
          w?.code?.toLowerCase() === it?.currency_code?.toLowerCase() &&
          w?.network?.toLowerCase() === it?.currency_network?.toLowerCase()
        )

        const rate = +(wallet?.rate ?? 1)

        amount += +it.withdraw.available_amount * +rate
        earn += +it.total_earns * +rate
      })

      amount = countDecimalPlaces(amount) > 6 ? floorNumber(amount, 6) : amount
      earn = countDecimalPlaces(earn) > 2 ? floorNumber(earn, 2) : earn
      setTotalAmount(amount)
      setTotalEarns(earn)
    } catch (error) {}
  }

  return (
    <div className={styles.savings}>
      <div className={styles['savings-data']}>
        <div className={styles['savings-data__item']}>
          <p>{t('total_amount')}</p>
          <h5>${formatNumberWithSpaces(Number(totalAmount) ?? 0) ?? ''}</h5>
        </div>

        <div className={styles.line}></div>

        <div className={styles['savings-data__item']}>
          <p>{t('total_earned_capital')}</p>
          <h5>${formatNumberWithSpaces(+totalEarns) ?? ''}</h5>
        </div>
      </div>
    </div>
  )
}
